import CommonError from '../Common/CommonError'

const Error500Container = () => {
  return (
    <CommonError error="500" color="primary" src="sad" />
  )
}

export default Error500Container